"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Icon_1 = __importDefault(require("../Icon"));
var styles_1 = require("./styles");
var __1 = require("../..");
var Header = function (_a) {
    var title = _a.title, icon = _a.icon, materialIcon = _a.materialIcon, rightSection = _a.rightSection, style = _a.style, className = _a.className;
    return ((0, jsx_runtime_1.jsxs)(styles_1.Header, __assign({ style: style, className: className }, { children: [(0, jsx_runtime_1.jsxs)(__1.Flex, { children: [(0, jsx_runtime_1.jsxs)(styles_1.SquareIconContiner, __assign({ "data-testid": "data-grid-icon-".concat(icon) }, { children: [typeof icon === 'string' ? (0, jsx_runtime_1.jsx)(Icon_1.default, { size: "s", name: icon }) : icon, materialIcon && (0, jsx_runtime_1.jsx)(__1.MaterialIcon, { size: "s", name: materialIcon })] })), (0, jsx_runtime_1.jsx)(styles_1.DataGridTitle, { children: title })] }), rightSection && (0, jsx_runtime_1.jsx)(styles_1.RightSection, { children: rightSection })] })));
};
exports.Header = Header;
